import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { useTeleconsultContext } from "../../Contexts/TeleconsultContext";
import Button from "../../Components/Button";

const TeleconsultInstructions = () => {
  const { navigate } = useTeleconsultContext();

  const handleBack = (e) => {
    navigate(-1);
  };

  return (
    <div className="flex flex-col min-h-screen max-w-screen sm:bg-[#E7EEFA] items-start sm:items-center">
      <div className="flex flex-col w-full sm:w-148 sm:bg-white min-h-screen sm:min-h-0 items-start sm:items-center rounded-xl sm:mt-24 ">
        <div className="w-full grid grid-cols-1 divide-y">
          <div className="p-4">
            <KeyboardArrowLeftIcon
              className="absolute cursor-pointer"
              onClick={handleBack}
            />
            <div className="text-center font-semibold text-[#1F2328]">
              Talk to a Doctor
            </div>
          </div>

          <div className="p-5">
            <div>
              <div className="font-bold text-2xl text-[#1F2328]">
                Instructions
              </div>

              <div className="mt-5">
                <div className="font-semibold">1. Preparation:</div>
                <div className="text-[#60656D] ml-1 mt-1">
                  ● Find a quiet, well-lit space with minimal distractions.
                </div>
                <div className="text-[#60656D] ml-1">
                  ● Have your medical records and questions ready.
                </div>
                <div className="text-[#60656D] ml-1">
                  ● Ensure a stable internet connection if using a device.
                </div>
              </div>

              <div className="mt-5">
                <div className="font-semibold">
                  2. Dialing the Hotline Number:
                </div>
                <div className="text-[#60656D] ml-1 mt-1">
                  ● Dial the provided hotline number to connect with your
                  healthcare provider.
                </div>
              </div>

              <div className="mt-5">
                <div className="font-semibold">3. During the Call:</div>
                <div className="text-[#60656D] ml-1 mt-1">
                  ● Greet your healthcare provider and introduce yourself.
                </div>
                <div className="text-[#60656D] ml-1 mt-1">
                  ● Clearly discuss your health concerns or questions.
                </div>
                <div className="text-[#60656D] ml-1 mt-1">
                  ● Listen actively and ask for clarification if needed.
                </div>
                <div className="text-[#60656D] ml-1 mt-1">
                  ● Follow any instructions provided during the call.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white flex-grow" />
        <div className="flex flex-col sm:items-end items-center w-full px-4 mb-5">
          <Button
            className="h-12 w-full transition ease-in-out delay-75 rounded-xl text-white"
            onClick={() => navigate("/teleconsult-voice/landline-number")}
          >
            Continue
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TeleconsultInstructions;
